module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/icon/icon.component.scss
// module id = ./src/app/features/icon/icon.component.scss
// module chunks = main